export default __webpack_public_path__ + "static/media/01_Arch_olang.e5dbff99.jpg";